/** 글자 폭 측정 기준 크기(T5). 줄바꿈 판단이 표시 축척과 무관하도록 이 크기로 재서 mm 로 환산한다. */
export const REFERENCE_FONT_PX = 100;
/** faux 굵게 — 채우기 위에 외곽선. 두께 = 글자 px × 이 값(T3). */
export const FAUX_BOLD_STROKE_RATIO = 1 / 24;
/** faux 기울임 — 가로 기울기(FreeType 합성 기울임 값, ≈12°)(T3). */
export const FAUX_ITALIC_SKEW = 0.2126;
export const UNDERLINE_OFFSET_EM = 0.1;
export const UNDERLINE_THICKNESS_EM = 0.06;
export const STRIKETHROUGH_OFFSET_EM = 0.3;
/** 기준선 위치 — 줄 상자 안에서 글자 크기의 이 비율만큼 아래가 기준선이다(브라우저·cairo 공통 근사). */
export const TEXT_ASCENT_EM = 0.8;

/** 폰트는 항상 보통 굵기·정체로 요청한다. 굵게·기울임은 렌더러가 합성한다(T3). */
export const fontString = (fontPx: number, familyName: string): string =>
  `${fontPx}px "${familyName}"`;
